import React, { useEffect } from "react";
import Space from "../../ui/Space";
import CategorySelectorInput from "../../ui/CategorySelectorInput";
import { KBD } from "../../utils/Keybindings";
import Label from "../../ui/Label";
import Spin from "../../ui/Spin";
import Input from "../../ui/Input";
import Float from "../../ui/Float";
import { kbdEvent, showConfirm, showHelp } from "../../utils/Utils";
import Button from "../../ui/Button";
import { listen } from "../../hooks/Listener";
import { showError, showMessage } from "../../ui/Message";
import { pubCall } from "../../utils/PubSub";
import { useTabs } from "../../hooks/useTabs";
import { drawPicker } from "../../popovers/Picker";

export default function ViewFileSearch(props) {

    const { controller = "", callback = () => { }, route = "", searchObj = {} } = props; 

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(
        [
            { key: "term", value: searchObj?.term },
            { key: "direction", value: searchObj?.direction },
        ],
        "term" // the field initially selected...
    );


    const search = () => {
        callback({
            term: getVal("term"),
            direction: getVal("direction"),
        });
    }

    useEffect(() => {
        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const options = [
            { value: "T", label: "Top" },
            { value: "B", label: "Bottom" },
            { value: "U", label: "Up" },
            { value: "D", label: "Down" },
        ]

        const actions = [
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.PAGE_DOWN, action: search },
            {
                key: KBD.PAGE_UP, action: () => {

                    if (index !== "direction") { return; }
                    drawPicker({
                        controller : controller,
                        value: getVal("direction"), ref: refs?.current[index], route: route, callback: (e) => {
                            update("direction", e)
                        }, offset: [0, 10],
                        options: options
                    })

                }
            },
            { key: KBD.ESCAPE, action: callback },
            { key: KBD.ENTER, action: search },
        ];
        const cleanup = listen(controller, route, actions, () => { }, [
            KBD.ARROW_DOWN,
            KBD.ARROW_UP,
            KBD.TAB,
            KBD.SHIFT_TAB,
            KBD.ESCAPE,
            KBD.ENTER,
            KBD.PAGE_UP,
            KBD.PAGE_DOWN,
            KBD.CTRL_C,
            KBD.CTRL_V,
        ]);
        return cleanup;
    }, [index, tabs]);

    return (
        <div>
              
            <div className="shim" /><div className="shim" />
            <Label style={{ "textAlign": "left" }} >Search for</Label><div className="shim" />
            <Input style={{ "textAlign": "left" }} {...editProps("term")} uppercase maxLength={40} autoselect width={300} value={getVal("term")} />
            <div className="shim" /><div className="shim" />
            <Label style={{ "textAlign": "left" }} >From:</Label><div className="shim" />
            <Space size={10}>
                <Input onFocus={() => setIndex("direction")} doubleclick={KBD.PAGE_UP} style={{ "textAlign": "center" }} onChange={(str) => {
                    let lastChar = str.charAt(str.length - 1) || "";
                    update("direction", lastChar)
                }} controlled edit ref={el => (refs.current["direction"] = el)} chars={["T", "B", "U", "D"]} uppercase autoselect width={20} value={getVal("direction")} />
                <Label><em>[T]op [B]ottom or [U]p [D]own from here </em></Label>
            </Space>
            <div className="shim" /><div className="shim" /><div className="shim" />
            <Float>
                <div></div>
                <Space>
                    <Button kbd={KBD.ESCAPE} onClick={() => kbdEvent(KBD.ESCAPE)} >Cancel</Button>
                    <Button kbd={KBD.PAGE_DOWN} onClick={() => kbdEvent(KBD.PAGE_DOWN)} type="secondary">Search</Button>
                </Space>
            </Float>
        </div>
    );
}
